import { ItemOffer } from "@/types";
import { atom } from "jotai";

const indoorItemOffersAtom = atom<ItemOffer[]>([]);

export default indoorItemOffersAtom;
